import { LocalMessage } from '../conversation';
import { QAPairSupportMessageTypes, useQAPairAIReplyError } from './useQAPair';
import { toNumber } from 'lodash-es';

const cacheValidPeriod = localStorage.getItem('VALID_PERIOD');
/** 有效期 24 小时 */
export const VALID_PERIOD = cacheValidPeriod ? parseInt(cacheValidPeriod) : 24 * 60 * 60 * 1000;

/**
 * 消息上标记 "AI 回复有误，提交正确答案" 按钮
 */
export const useSenderQAPairMsgMark = () => {
  const aiReplyErrorPermission = useQAPairAIReplyError();

  return (conversation: Conversation.Conversation, message: LocalMessage) => {
    if (!aiReplyErrorPermission) {
      return false;
    }
    const { topBarInfo } = conversation;
    const knowledgeReplies = topBarInfo?.knowledgeReplies;
    if (!knowledgeReplies) {
      return false;
    }

    const { messageType, sendTime: messageSendTime } = message;

    // 条件1: messageType 属于 QAPairSupportMessageTypes
    if (!QAPairSupportMessageTypes.includes(messageType)) {
      return false;
    }

    // 条件2: knowledgeReplyValues 中 query 存在消息时间小于 message 的时间，且两个消息之间的间隔不大于 VALID_PERIOD
    const messageTime = toNumber(messageSendTime);
    const knowledgeReplyValues = Object.values(knowledgeReplies);
    const hasValidReply = knowledgeReplyValues?.some((knowledgeReply) => {
      const itemInfo = knowledgeReply.query.itemInfo;
      if (!itemInfo) {
        return false;
      }
      const querySendTime = toNumber(knowledgeReply.query.sendTime);
      const timeDiff = messageTime - querySendTime;
      return querySendTime < messageTime && timeDiff <= VALID_PERIOD;
    });

    return hasValidReply;
  };
};
